var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.3749V15.4999H3.625L12.8417 6.28322L9.71667 3.15822L0.5 12.3749ZM15.2583 3.86655C15.5833 3.54155 15.5833 3.01655 15.2583 2.69155L13.3083 0.741553C12.9833 0.416553 12.4583 0.416553 12.1333 0.741553L10.6083 2.26655L13.7333 5.39155L15.2583 3.86655Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 12.3749V15.4999H3.625L12.8417 6.28322L9.71667 3.15822L0.5 12.3749ZM15.2583 3.86655C15.5833 3.54155 15.5833 3.01655 15.2583 2.69155L13.3083 0.741553C12.9833 0.416553 12.4583 0.416553 12.1333 0.741553L10.6083 2.26655L13.7333 5.39155L15.2583 3.86655Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/IconEdit.8dddd7b20573ed176a487cad14f567bf.svg";
export { ForwardRef as ReactComponent };